import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Asset} from "./fields";
import {Layer} from "./Shot";
import {host} from "./api";


export interface LayersState {
    layers?: Array<Layer>,
    collection?: Array<Layer>,
    lore?: Array<Layer>,
    status: Status,
    error: string | null | undefined
}

const initialState: LayersState = {
    layers: [],
    status: Status.Idle,
    error: null,
}


export const fetchLayersCollection = createAsyncThunk('fetchLayersCollection', async (params: { projectId: number, storyId: number}) => {
    const response = await axios.get(`${host}/stories/${params.storyId}/layers`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const fetchLayersLore = createAsyncThunk('fetchLayersLore', async (params: { projectId: number, componentId: number}) => {
    const response = await axios.get(`${host}/components/${params.componentId}/assets`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveLayer = createAsyncThunk('saveLayer', async (params: { projectId: number, storyId: number, layer: Layer }) => {
    const response = await axios.post(`${host}/layers`,
        {...params.layer, story: {id: params.storyId}},
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveLocationLayer = createAsyncThunk('saveLocationLayer', async (params: { projectId: number, locationId: number, storyId: number, layer: Layer }) => {
    const response = await axios.post(`${host}/locations/${params.locationId}/layers`,
        {...params.layer, story: {id: params.storyId}},
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveObjectLayer = createAsyncThunk('saveObjectLayer', async (params: { projectId: number, objectId: number, storyId: number, layer: Layer }) => {
    const response = await axios.post(`${host}/objects/${params.objectId}/layers`,
        {...params.layer, story: {id: params.storyId}},
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveCharacterLayer = createAsyncThunk('saveCharacterLayer', async (params: { projectId: number, characterId: number, storyId: number, layer: Layer }) => {
    const response = await axios.post(`${host}/characters/${params.characterId}/layers`,
        {...params.layer, story: {id: params.storyId}},
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteLayer = createAsyncThunk('deleteLayer', async (params: { projectId: number, layerId: number }) => {
    const response = await axios.delete(`${host}/layers/${params.layerId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const layerSlice = createSlice({
    name: 'layers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(saveLayer.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveLayer.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteLayer.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteLayer.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(fetchLayersLore.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchLayersLore.fulfilled, (state, action) => {
                state.status = Status.Idle
                state.lore = action.payload.map((asset: Asset) => {
                    return {
                        ...asset,
                        source: asset.content,
                        layers: [{...asset, source: asset.content, type: 'Layer'}],
                        scale: 100,
                        type: 'Layer'
                    }
                })
            })
            .addCase(fetchLayersCollection.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchLayersCollection.fulfilled, (state, action) => {
                state.status = Status.Idle
                state.collection = action.payload
            })
    }
})
export default layerSlice.reducer;